export default "__VITE_ASSET__CQAHerAM__"